import Input from "./input";
import Select from "./select";
import TextArea from "./textarea";
import FileInput from "./file-input";
import DateTimeInput from "./date-time-input";
import CategoryInput from "./category-input";

const FormControl = {
  Input,
  Select,
  TextArea,
  FileInput,
  DateTimeInput,
  CategoryInput
};

export default FormControl;
